<template>
  <div class="documnet-container">
    <my-head></my-head>
    <div class="document-main">
      <div class="nev-meun">
        <ul class="nav-meun-ul">
          <li class="nav-meun-item" v-for="(nav,index) in nav" :key="index">
            <div class="nav-caption" :class="{'active':nav.isOpen}" @click="selectNav(index)">
              <span>{{nav.name}}</span>
            </div>
            <ul class="children-list" v-show="nav.isOpen">
              <li class="children-item" v-for="(item,j) in nav.children" :key="j">
                <router-link :to="item.path">{{item.name}}</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="document-content">
        <router-view></router-view>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>
<script>
import MyHead from "@/components/MyHead.vue";
import MyFooter from "@/components/MyFooter.vue";
export default {
  name: "document",
  components: {
    MyHead,
    MyFooter
  },
  data() {
    return {
      nav: [
        {
          name: "快速入门",
          isOpen: false,
          children: [
            {
              name: "业务说明",
              path: "/document"
            },
            {
              name: "申请接入",
              path: "/document/description/apply"
            },
            {
              name: "订单流程",
              path: "/document/description/order"
            },
            {
              name: "支付流程",
              path: "/document/description/pay"
            },
            {
              name: "开发注意事项",
              path: "/document/description/develop"
            }
          ]
        },
        {
          name: "接口文档",
          isOpen: false,
          children: [
            {
              name: "公共参数",
              path: "/document/public/params"
            },
            {
              name: "全局返回码说明",
              path: "/document/public/error"
            },
            {
              name: "创建订单",
              path: "/document/order/create"
            },
            {
              name: "订单详情",
              path: "/document/order/info"
            },
            {
              name: "计算价格",
              path: "/document/computed/price"
            },
            {
              name: "查询快递列表",
              path: "/document/express"
            },
            {
              name: "商品搜索",
              path: "/document/sku/search"
            },
            {
              name: "物料详情",
              path: "/document/sku/info"
            }
          ]
        }
      ]
    };
  },
  beforeMount() {
    this.initNav();
  },
  methods: {
    initNav() {
      const currentPath = this.$route.path;
      let navList = this.nav;
      navList.forEach((item, index) => {
        let childrenList = item.children;
        childrenList.forEach(children => {
          if (children.path == currentPath) {
            item.isOpen = true;
          }
        });
      });
    },
    /**
     * @description 点击导航的下表
     */
    selectNav(clickIndex) {
      this.nav.forEach((item, index) => {
        if (index == clickIndex) {
          item.isOpen = true;
        } else {
          item.isOpen = false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.document-main {
  margin: 0 auto 0px;
  padding: 15px 0 90px 0;
  width: 1200px;
  background-color: #fff;
  &::after {
    clear: both;
    content: "";
    visibility: hidden;
    display: block;
    font-size: 0;
    height: 0;
  }
  .nev-meun {
    float: left;
    padding: 10px 0 180px;
    width: 240px;
    -moz-box-shadow: 0px 0px 4px 0px rgba(218, 218, 218, 1);
    -webkit-box-shadow: 0px 0px 4px 0px rgba(218, 218, 218, 1);
    box-shadow: 0px 0px 4px 0px rgba(218, 218, 218, 1);
    .nav-meun-ul {
      .nav-meun-item {
        text-align: left;
        width: 240px;
        .nav-caption {
          position: relative;
          z-index: 10;
          padding-left: 15px;
          height: 40;
          line-height: 40px;
          cursor: pointer;
          &.active {
            background-color: #f5fff2;
            &:hover {
              background-color: #f5fff2;
            }
            &:before {
              position: absolute;
              z-index: 10;
              content: "";
              display: block;
              top: 0;
              left: 0;
              height: 40px;
              width: 1px;
              background-color: #4bc227;
            }
          }
          &:hover {
            background-color: #f6f6f6;
          }
        }
        .children-list {
          width: 240px;
          .children-item {
            height: 40px;
            a {
              display: block;
              padding-left: 40px;
              height: 40px;
              line-height: 40px;
              font-size: 14px;
              color: #777;
              outline: none;
              &:hover {
                color: #4bc227;
              }
              &.router-link-exact-active {
                color: #4bc227;
              }
            }
          }
        }
      }
    }
  }
  .document-content {
    float: right;
    width: 960px;
  }
}
</style>
